
import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error-state',
  standalone: true,
  imports: [MatIconModule, MatButtonModule],
  template: `
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <span>{{ message() }}</span>
      @if (showRetry()) {
        <button mat-stroked-button (click)="retry.emit()">
          {{ buttonLabel() }}
        </button>
      }
    </div>
  `,
  styles: [
    `
      .error-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 48px;
        gap: 16px;
        background: #fef2f2;
        border-radius: 8px;

        mat-icon {
          font-size: 48px;
          width: 48px;
          height: 48px;
          color: var(--dark-red-error);
        }

        span {
          color: var(--dark-red-error);
          font-size: 1rem;
          font-weight: 600;
        }

        button {
          border-radius: 8px;
        }
      }
    `,
  ],
})
export class ErrorStateComponent {
  readonly message = input('An error occurred. Please try again.');
  readonly showRetry = input(true);
  readonly buttonLabel = input('Retry');
  readonly retry = output<void>();
}
